import GreetingProfile from "./greeting-profile";

export default GreetingProfile;
